<template>
    <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 11.5 12 20a5.5 5.5 0 0 1-7.78-7.78l8.06-8.06a3.5 3.5 0 0 1 4.95 4.95l-8.06 8.06a1.5 1.5 0 0 1-2.12-2.12L14.9 7.1" />
    </svg>
</template>
